import moment, { Moment } from 'moment';
import { themeColor } from '../../mui-theme';
import { DateRanges } from '../components/search-results-screen-head';
import {
  DateRange,
  ReactDateRangePickerDateRanges,
  ReturnPolicyResponse,
} from '../interfaces/get-effective-return-policy-response';

const calendarSelectBackgroundColor = themeColor.passiveGreen; // '#DDEFDA';

export const getRangeDates = (dateRange: DateRange) => {
  const startDate = moment(dateRange.startDate);
  const endDate = moment(dateRange.endDate);
  return `${startDate.format('MM/DD/YYYY')} - ${endDate.format('MM/DD/YYYY')}`;
};

export const createNewDateRange = (numberOfDaysToSubtract: number, timeInterval = 'd') => {
  return moment()
    .subtract(numberOfDaysToSubtract, timeInterval === 'm' ? 'month' : 'd')
    .toDate();
};

export const setPolicyMax = (setDateRange: Function, returnPolicy?: ReturnPolicyResponse) => {
  // ToDo: check whether we want receiptLookupPeriod to be `receiptLookupPeriod + current day` or just `receiptLookupPeriod`
  if (returnPolicy) {
    setDateRange({
      startDate: createNewDateRange(returnPolicy.receiptLookupPeriod),
      endDate: moment().toDate(),
      color: calendarSelectBackgroundColor,
    });
  }
};

export const setYesterday = (setDateRange: Function) => {
  setDateRange({
    startDate: createNewDateRange(1),
    endDate: moment().toDate(),
    color: calendarSelectBackgroundColor,
  });
};

export const setLastWeek = (setDateRange: Function) => {
  setDateRange({
    startDate: createNewDateRange(7),
    endDate: moment().toDate(),
    color: calendarSelectBackgroundColor,
  });
};

export const isReceiptLookupPeriodGreaterThanAMonth = (receiptLookupPeriod: number) => {
  if (receiptLookupPeriod) {
    return receiptLookupPeriod > 30;
  }
};

export const isReceiptLookupPeriodGreaterThanAWeek = (receiptLookupPeriod: number) => {
  if (receiptLookupPeriod) {
    return receiptLookupPeriod > 7;
  }
};

export const setLastMonth = (setDateRange: Function) => {
  setDateRange({
    startDate: createNewDateRange(1, 'm'),
    endDate: moment().toDate(),
    color: calendarSelectBackgroundColor,
  });
};

export const handleDateRangeSelect = (
  ranges: ReactDateRangePickerDateRanges,
  setDateRange: Function,
) => {
  if (ranges && ranges.range1) {
    setDateRange(ranges.range1);
  }
};

export const isInvalidDate = (returnPolicy: ReturnPolicyResponse, date: Date) => {
  let isInvalid = false;
  if (returnPolicy) {
    const dateObj = moment(date);
    // ToDo: check whether we want receiptLookupPeriod to be `receiptLookupPeriod + current day` or just `receiptLookupPeriod`
    const startDate = moment().subtract(returnPolicy.receiptLookupPeriod + 1, 'd');
    if (dateObj.isAfter(moment()) || dateObj.isBefore(startDate)) {
      isInvalid = true;
    }
  }
  return isInvalid;
};

const getFormattedTime = (dateString: any): Moment => {
  return moment(dateString.startOf('day').format('YYYY-MM-DDT00:00:00'));
};
export const getDateRangeInterval = (rangeType: DateRanges): DateRange => {
  const endDate = moment();
  let startDate: moment.Moment;

  switch (rangeType) {
    case DateRanges.yesterday:
      startDate = getFormattedTime(moment().subtract(1, 'day'));
      break;
    case DateRanges.lastWeek:
      startDate = getFormattedTime(moment().subtract(7, 'days'));
      break;
    case DateRanges.lastMonth:
      startDate = getFormattedTime(moment().subtract(1, 'month'));
      break;
    default:
      startDate = getFormattedTime(moment());
      break;
  }

  const sd = startDate.toDate();
  sd.setUTCHours(0, 0, 0, 0);
  return {
    startDate: sd,
    endDate: endDate.toDate(),
  };
};
